export default "__VITE_ASSET__DjnBWDCl__"